import StatusBadge from "../../midpoint/intelligence/StatusBadge";
import FavoriteButton from "../FavoriteButton";
import PropertyFactsGrid from "./PropertyFactsGrid";
import PropertyContactActions from "./PropertyContactActions";
import {
  formatDetailPrice,
  formatPricePeriodLabel,
} from "../../../utils/propertyDetailFormat";
import { getSourceCountLabel } from "../../../utils/propertyTrustBadges";
import { useLocale } from "../../../intl";

const PropertySummaryCard = ({ property, onShare }) => {
  const { t } = useLocale();
  const priceLabel = formatDetailPrice(property);
  const periodLabel = formatPricePeriodLabel(property.pricePeriod);
  const locationParts = [
    property.neighborhood,
    property.municipality || property.city,
    property.department,
  ].filter(Boolean);

  return (
    <aside className="property-detail-summary" aria-label={t("realEstate.propertySummary")}>
      <div className="property-detail-summary__badges">
        <StatusBadge
          label={property.availabilityBadge?.label || t("realEstate.available")}
          tone={property.availabilityBadge?.tone || "success"}
        />
        {property.freshnessBadge?.label ? (
          <StatusBadge
            label={property.freshnessBadge.label}
            tone={property.freshnessBadge.tone || "neutral"}
          />
        ) : null}
        {property.sourceTrustBadge?.label ? (
          <StatusBadge
            label={property.sourceTrustBadge.label}
            tone={property.sourceTrustBadge.tone || "neutral"}
          />
        ) : null}
      </div>

      {priceLabel ? (
        <p className="property-detail-summary__price">
          {priceLabel}
          {periodLabel ? <span className="property-detail-summary__period">{periodLabel}</span> : null}
        </p>
      ) : null}

      <h1 className="property-detail-summary__title">{property.title || t("realEstate.properties")}</h1>

      <p className="property-detail-summary__location">
        {locationParts.length
          ? locationParts.join(", ")
          : property.locationPending
            ? t("realEstate.locationPending")
            : t("realEstate.defaultLocation")}
      </p>

      {property.activeSourceCount > 0 ? (
        <p className="property-detail-summary__sources">
          {getSourceCountLabel(property.activeSourceCount)}
          {property.primarySourceName ? ` · Primary: ${property.primarySourceName}` : ""}
        </p>
      ) : null}

      <div className="property-detail-summary__actions">
        <FavoriteButton property={property} className="property-detail-summary__favorite" />
        {onShare ? (
          <button type="button" className="midpoint-share-button" onClick={onShare}>
            {t("common.share")}
          </button>
        ) : null}
      </div>

      <PropertyFactsGrid property={property} />
      <PropertyContactActions property={property} />
    </aside>
  );
};

export default PropertySummaryCard;
